import WebSocketClient from '../helpers/webSocketClient';
import env             from '../env';

export default new WebSocketClient(`${env.MESSENGER_HOST}/sync`);



// WEBPACK FOOTER //
// ./src/services/SocketService.ts